/**
 * Page-level CSS override for PylonChat in drawer contexts
 *
 * This file is automatically imported by the DrawerContainer component.
 * When any drawer is open, a 'drawer-open' class is added to the body element,
 * which triggers this override.
 *
 * No manual imports or configuration needed in consuming components.
 */

/* Override PylonChat bubble frame container position when drawer is open */
body.drawer-open .PylonChat-bubbleFrameContainer {
    bottom: 61px !important;
}
